import { Box } from '@mui/material';
import { DateTime } from '../../utility/luxon';
import { FC } from 'react';
import { useRouter } from 'next/router';

interface OfferExpireTimeProps {
  time: string;
}

export const OfferExpireTime: FC<OfferExpireTimeProps> = ({ time }) => {
  const router = useRouter();

  const expireDate = DateTime.fromISO(time).toFormat('dd/MM/yyyy');
  const expireTime = DateTime.fromISO(time, { locale: router.locale }).toFormat('t');

  return (
    <Box>
      <Box component='span'>
        &nbsp;
        {expireDate}
      </Box>
      {expireTime !== '11:59 PM' && expireTime !== '11:59 م' && (
        <Box component='span'>&nbsp;&middot;&nbsp;{expireTime}</Box>
      )}
    </Box>
  );
};
